<template>
  <div class="page">
    <div class="content">
      <div class="tabs-wrap">
        <el-tabs class="tabs" v-model="activeName">
          <el-tab-pane name="first">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/douyin.png" alt="" />
              抖音达人</span>
            <First v-if="activeName === 'first'" @changeQuery="changeQuery">
            </First>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/kuaishou.png" alt="">快手达人</span>
            <Second v-if="activeName === 'second'" @changeQuery="changeQuery">
            </Second>
          </el-tab-pane>
          <el-tab-pane name="fourth">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/bilibili.png"
                alt="">bilibili UP主</span>
            <Fourth v-if="activeName === 'fourth'" @changeQuery="changeQuery"></Fourth>
          </el-tab-pane>
          <el-tab-pane name="third">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/xhs.png" alt="">小红书达人</span>
            <RedBook v-if="activeName === 'third'" @changeQuery="changeQuery"></RedBook>
          </el-tab-pane>
          <el-tab-pane name="other">
            <span slot="label" class="label"><img class="label_icon" src="../../assets/other.png" alt="">其他平台达人</span>
            <otherPlatformSearch v-if="activeName === 'other'" @changeQuery="changeQuery"></otherPlatformSearch>
          </el-tab-pane>
        </el-tabs>

        <!-- <div class="right-btns-wrap">
          <el-button type="primary" round size="small" @click="toAddTalent">
            <i class="el-icon-plus" style="margin-right: 6px;"></i>新增达人
          </el-button>
        </div> -->
      </div>


      <Table1 v-if="activeName === 'first'" :commonQuery="commonQuery"
         :isShowCalendar="isShowCalendar" @changeQuery="changeQuery">
      </Table1>
      <Table2 v-if="activeName === 'second'" :commonQuery="commonQuery2" :isShowCalendar="isShowCalendar"
        @changeQuery="changeQuery">
      </Table2>
      <Table4 v-if="activeName === 'fourth'" :commonQuery4="commonQuery4"  :isShowCalendar="isShowCalendar" :tableVideoData4="tableVideoData4"
        @changeQuery="changeQuery">
      </Table4>
      <!-- 新增小红书 -->
      <Table3 v-if="activeName === 'third'" :commonQuery="commonQuery3" :tableVideoData3="tableVideoData3"
        @changeQuery="changeQuery">
      </Table3>
      <!-- 其他平台达人列表 -->
      <TableOtherPlatform v-if="activeName === 'other'" :commonQuery="commonQueryOther"
        @changeQuery="changeQuery">
      </TableOtherPlatform>

      <!-- 自孵化排期入口移动到'资产账号档期'页面 -->
      <!-- <div class="helper_enter" v-if="activeName !== 'third'" @click="calendarListShow = true">
        <img src="../../assets/helper_logo.png" alt="">
        <div class="enter_text">
          自孵化排期
        </div>
      </div> -->
    </div>

    <!-- 自孵化排期列表 -->
    <CalendarList :outerDiaVisible.sync="calendarListShow" :plat="platMap[activeName]"></CalendarList>

  </div>
</template>

<script>
import Table1 from './table/table1.vue'
import Table2 from './table/kstable.vue'
import Table4 from './table/table4.vue'
import Table3 from "./table/table3.vue"
import TableOtherPlatform from "./table/tableOtherPlatform.vue"
export default {
  name: 'routerviewPage',
  components: {
    First: ()=> import('./tabs/first.vue'),
    Second: ()=> import('./tabs/second.vue'),
    Fourth: ()=> import('./tabs/fourth.vue'),
    RedBook: () => import("./tabs/xhs.vue"),
    otherPlatformSearch: () => import("./tabs/otherPlatformSearch.vue"),
    Table1,
    Table2,
    Table4,
    Table3,
    TableOtherPlatform,
    CalendarList: () => import("@/components/calendar/calendar-list.vue"),
  },
  data() {
    return {
      activeName: "first",
      //tab1
      marketing_target: 1,
      tableVideoData: '',
      commonQuery: {},
      //tab1 end
      //tab2
      commonQuery2: {},
      tableVideoData2: '',
      //tab2 end
      //tab4
      commonQuery4: {},
      tableVideoData4: '',
      //tab4 end
      calendarListShow: false,
      platMap: {
        "first": "抖音",
        "second": "快手",
        "fourth": "B站"
      },
      isShowCalendar: 0,
      commonQuery3: {}, //小红书
      tableVideoData3: '',

      commonQueryOther: {},

    };
  },
  created() {
    if (window.performance.navigation.type === 0 || window.performance.navigation.type === 1 || window.performance
      .navigation.type === 2) {
      //判断浏览器刷新行为，清除session
      let inSalesGroup = window.sessionStorage.getItem('inSalesGroup')
      let name = window.sessionStorage.getItem('name')
      window.sessionStorage.clear()
      window.sessionStorage.setItem('inSalesGroup', inSalesGroup)
      window.sessionStorage.setItem('name', name)
    }
    this.getCalendarAuth()
  },
  watch: {
    activeName: {
      handler(val) {
        switch (val) {
          case 'first':
            localStorage.setItem('plat', 'dy')
            break;
          case 'second':
            localStorage.setItem('plat', 'ks')
            break;
          case 'fourth':
            localStorage.setItem('plat', 'blbl')
            break;
          case 'third':
            localStorage.setItem('plat', 'xhs')
            break;
          case 'other':
            localStorage.setItem('plat', 'other')
          break;
        }
      },
      immediate: true
    }
  },
  methods: {
    changeQuery(query, which) {
      if (which === "commonQuery") {
        this.commonQuery = query
      } else if (which === "commonQuery2") {
        this.commonQuery2 = query
      } else if (which === "commonQuery4") {
        this.commonQuery4 = query
      } else if (which === "commonQuery3") {
        this.commonQuery3 = query
      } else if (which === "commonQueryOther") {
        this.commonQueryOther = query
      }
    },
    getCalendarAuth() { //获取自孵化达人排期的权限
      this.$axios.post('/api.php?m=case|api|gx&a=pqeditrule', {}, {headers: { showLoading: false}}).then(res => {
        // all_show 控制批量锁档
        window.localStorage.setItem('isShowCalendar', res.all_show)
        this.isShowCalendar = res.all_show
      }).catch( err => console.log('err :>> ', err))
    },
    toAddTalent() {
      let origin = location.origin.includes('test') ? 'http://test.erp.changwankeji.com:8080' : 'https://erp.changwankeji.com:8188'
      let url = `${origin}/dist/index.html#/crmlibrary/add`
      window.open(url)
    }
  },
  mounted() {

  }
};
</script>

<style lang="less">
.kol_table{
  .el-dialog__body {
    padding-top: 0;
  }
  .el-checkbox__label {
    color:#1d2129;
  }
  .el-radio .el-radio__label {
    color:#1d2129;
  }


}
.same {
  background: url("../../assets/search_same.png") no-repeat center;
  width: 15px;
  height: 14px;
  margin: auto;
  background-size: cover;
  cursor: pointer;
}

.page {
  width: 100%;
  // background: #f6f6f6;
  background: linear-gradient(rgb(255, 254, 252) 0%, rgb(255, 255, 255) 100%);
  padding: 8px 0 50px 0;
}

.page .content {
  width: calc(100% - 100px);
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
}

.tabs .el-tabs__header {
  padding: 20px 26px 0 26px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 6px;
  border-radius: 6px;
  height: 62px;
  box-sizing: border-box;
  margin-bottom: 20px !important;
}

.bz_content .el-tabs__header{
  box-shadow: none !important;
}
.tabs .el-tabs__content {
  padding: 20px;
  padding-bottom: 0;
  background: #fff;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 6px;
}


.tabs .el-tabs__nav-wrap::after {
  display: none;
}

.tabs .el-tabs__item.is-active {
  color: #000;
}

.tabs .label {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #4E5969;
  display: flex;
  align-items: center;
  line-height: 20px;
}

.tabs .label .label_icon {
  margin-right: 8px;
}

.tabs .el-tabs__active-bar {
  background-color: #ff5c00;
}

.page .content .search {
  /* position: absolute;
    top: 11px;
    right: 26px; */
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  width: 460px;
  height: 38px;
  background: #FFFFFF;
  border: 1px solid #ff6f28;
  border-radius: 6px;
  // border-radius: 2px;
}

.page .content .search .el-input__inner {
  border: none;
  border-radius: 6px;
}

.page .content .search button {
  width: 90px;
  height: 38px;
  border: none;
  border-radius: 6px;
  background-color: #FF5C00;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page .content .search button:hover {
  cursor: pointer;
  background-color: #FF4E00;
}

.page .content .search button img {
  margin-right: 4px;
}

.condition {
  width: 100%;
  margin-top: -16px;
  border-radius: 6px;
}

.item {
  display: flex;
  margin-top: 20px;
}

.condition>.item:nth-child(1) {
  margin-top: 35px;
}


.condition .item .single {
  display: flex;
  width: 100%;
}

.pop4 .el-checkbox__inner,
.condition .item .single .pop2 .el-checkbox__inner,
.condition .item .single .pop3 .el-checkbox__inner {
  display: none;
}

.pop4 .el-checkbox__label,
.condition .item .single .pop2 .el-checkbox__label,
.condition .item .single .pop3 .el-checkbox__label {
  padding: 4px 10px;
  height: 18px;
  border-radius: 2px;
  text-align: center;
  line-height: 22px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.pop4 .el-checkbox__label {
  margin-right: 0;
}


.pop4 .el-checkbox__input.is-checked+.el-checkbox__label,
.condition .item .single .pop2 .el-checkbox__input.is-checked+.el-checkbox__label {
  background: #fff2eb;
}

.condition .item .single .pop3 .el-checkbox__input.is-checked+.el-checkbox__label {
  background: unset;
}

.condition .item .single .pop3 .el-checkbox__label {
  color: #ff5c00;
}

.condition .item .single {
  .my-checked {
    &.is-checked {
      .el-checkbox__label {
        background: #fff2eb;
      }
    }

    .el-checkbox__label {
      padding: 4px 10px;
      height: 18px;
      text-align: center;
      line-height: 22px;
      margin-bottom: 20px;
    }

    .el-checkbox__inner {
      display: none;
    }
  }
}

/* .item .options .pop4>>>.el-checkbox{
    margin-right: 0;
  } */

.item .des {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #1D2129;
  margin-right: 35px;
  margin-left: 6px;
  line-height: 24px;
  width: 60px;
  white-space: nowrap;

}
.selected-wrap{
  display: flex;
  align-items: start;
  margin-bottom: 20px;
  .des{
    display: flex;
    align-items: center;
  }
}

.options_close {
  max-height: 25px;
}

.options_open {
  max-height: none;
}

.item .options {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  .el-icon-close{
    font-size: 16px;
  }
}

.item .options .pop {
  margin-bottom: 20px;
}

.condition .el-radio {
  padding: 0 10px;
  height: 24px;
  border-radius: 2px;
  text-align: center;
  line-height: 24px;
  margin-right: 26px;
}


.condition .el-radio.is-checked {
  background: #fff2eb;
}

.condition .el-radio .el-radio__input {
  display: none;
}

.el-radio .el-radio__label {
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #999999;
}

.el-radio .el-radio__input.is-checked+.el-radio__label {
  color: #ff5c00;
}

.sub_list {
  display: flex;
  padding: 12px;
  box-sizing: border-box;
  flex-flow: row wrap;
  align-items: center;
  max-width: 1000px;
  gap: 14px;
}

.sub_list .sub_item {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #000;
}

.sub_list .sub_item:hover {
  cursor: pointer;
  color: #ff5c00;
}

// .sub_list .sub_item+.sub_item {
//   margin-left: 15px;
// }

.open_close {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #38a1ff;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  margin:0px 8px;
}

.multi {
  width: 60px;
  height: 26px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  box-sizing: border-box;
  margin-left: 27px;
}

.multi:hover {
  cursor: pointer;
  color: #38a1ff;
  border-color: #38a1ff;
}

.option_text {
  cursor: pointer;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #86909C;
  line-height: 24px;
}

.options .info_option+.info_option {
  margin-left: 30px;
}
.options .checkbox-wrap+.info_option {
  margin-left: 30px;
}

.options .info_option .el-popover {
  padding: 0;
}

.ecom .option_show {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  padding: 10px 15px;
  cursor: pointer;
}


.ecom .option_show:hover {
  color: #FF6F28;
}

.to_input {
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.to_input .el-input__inner {
  width: 100px;
  height: 34px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
}

.to_input .short_line {
  width: 9px;
  height: 2px;
  background: #666666;
  margin: 0 6px;
}

.double_btn {
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 4px;
  margin-top: 20px;
  width: 100%;
  .btn_1, .btn_2, .btn_3{
    margin: 0 0 0 10px;
  }
}

.double_btn .btn_1 {
  background: none;
  border: none;
  cursor: pointer;
  width: 80px;
  height: 32px;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #38a1ff;
  line-height: 32px;
  text-align: right;
}

.double_btn .btn_2 {
  width: 80px;
  height: 32px;
  cursor: pointer;
  background: #ff6f28;
  border-radius: 2px;
  border: none;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 32px;
}

.double_btn .btn_3 {
  width: 80px;
  height: 32px;
  cursor: pointer;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
}

// .fans_img_2 .double_btn .btn_3 {
//   margin-left: 140px;
// }

.fans_price {
  padding: 4px;
  width: 100%
}

.fans_price .son_option {
  padding: 10px 0;
}

.fans_price .son_option:hover {
  cursor: pointer;
  color: #ff6f28;
}

.area .el-cascader-panel {
  border: none;
}

.area .el-cascader-menu__list {
  padding: 12px 0;
}

.area .el-cascader-menu {
  border-right: solid 1px #f1f1f1;
}

.area .el-cascader-node.in-active-path,
.area .el-cascader-node.is-active,
.area .el-cascader-node.is-selectable.in-checked-path {
  font-weight: 500;
  color: #FF6F28;
}

.sex {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.sex .sex_item {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  padding: 10px 0px;
  cursor: pointer;
}

.sex .sex_item:hover {
  color: #FF6F28;
}

.fans_img {
  width: 316px;
  height: 280px;
  background: #FFFFFF;
  /* border: 1px solid #EBEEF5; */
  display: flex;
  flex-wrap: wrap;
  padding: 26px;
  box-sizing: border-box;
}

.fans_img .box {
  width: 120px;
}

.fans_img .box:nth-child(2n-1) {
  margin-right: 22px;
}

.fans_img .box .name_1 {
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
}

.fans_img .box .el-select {
  width: 100%;
  margin-top: 15px;
}

.fans_img .task {
  width: 100%;
  margin-right: 0 !important;
}




.fans_img_2 {
  width: 480px;
  // min-height: 280px;
  background: #FFFFFF;
  /* border: 1px solid #EBEEF5; */
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 4px;
}

.fans_img_2 .box {
  width: 200px;
  margin-bottom: 10px;
}

.fans_img_2 .box:nth-child(2n-1) {
  margin-right: 22px;
}

.fans_img_2 .box .name_1 {
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
}

.fans_img_2 .box .el-select {
  width: 100%;
  margin-top: 15px;
}

.fans_img_2 .task {
  width: 100%;
  margin-right: 0 !important;
}


.fans_img_3 {
  width: 480px;
  height: 320px;
  background: #FFFFFF;
  /* border: 1px solid #EBEEF5; */
  display: flex;
  flex-wrap: wrap;
  padding: 26px;
  box-sizing: border-box;
}

.fans_img_3 .box {
  width: 200px;
}

.fans_img_3 .box:nth-child(2n-1) {
  margin-right: 22px;
}

.fans_img_3 .box .name_1 {
  font-size: 12px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  padding-top: 10px;
}

.fans_img_3 .box .el-select {
  width: 100%;
  margin-top: 10px;
}

.fans_img_3 .task {
  width: 100%;
  margin-right: 0 !important;
}

.options .task_num {
  margin-right: 30px;
}

.options .el-checkbox {
  line-height: 24px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #86909C;
}

.question {
  position: relative;
  top: 2px;
  margin: 0 2px;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #FF6F28;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FF6F28;
  border-color: #FF6F28;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #FF6F28;
}

.condition .line {
  width: 100%;
  height: 1px;
  background: #F0F0F0;
  margin-top: 20px;
}

.options .el-tag {
  border: none;
  line-height: 24px;
  margin-bottom: 15px;
  margin-right: 15px;
  border-radius: 8px !important;
  padding: 0 14px 0 12px;
}

.options .el-tag+.el-tag {
}

.table_btn {
  border: none;
  width: 72px;
  height: 30px;
  background: #FF6F28;
  border-radius: 2px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  cursor: pointer;
}

.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding-left: 0;
  text-align: center;
}

.el-table .cell div {
  text-align: center;
}

.el-table .mcn_num {
  display: flex;
  justify-content: space-between;
}

.el-table .mcn_num .num_1 {
  color: #333333;
}

.el-table .mcn_num .sort_1 {
  color: #666666;
  cursor: pointer;
}

.thead_style {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  background: #fff;
}

.el-date-table,
.el-table th {
  background-color: #fff;
}

.el-table th.is-leaf {
  border-bottom: none
}

th {
  font-weight: 500;
}

.mcn_info {
  display: flex;
}

.mcn_info .head-wrap {
  width: 60px;
  height: 100%;
  margin-top: 30px;
  margin-right: 20px;

  .headimg{
    width: 100%;
    height: 60px;
    border: 1px solid #e0e0e0;
    border-radius: 50%;
  }
}

.mcn_info .mcn_detail {
  text-align: left !important;
}

.mcn_info .mcn_detail .name {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0;
  .i-calendar{
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}

.mcn_info .mcn_detail .tag {
  // height: 26px;
  background: #F6F6F6;
  border-radius: 2px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-align: center;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
  display: inline-block;
  padding: 0 8px;
  margin-right: 6px;

}

.mcn_info .mcn_detail .sex_icon {
  width: 14px;
  height: 14px;
}

.mcn_info .mcn_detail .addr {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  margin-top: 10px;
  text-align: left;
}

.mcn_info .mcn_detail .dec {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #999999;
  margin-top: 10px;
}

.price_text {
  font-size: 18px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 800;
  color: #FF5C00;
  line-height: 32px;
}

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #FF6F28;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #FF6F28;
}

.pages {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
}

.pages .el-pagination {
  padding: 2px 0;
}

.pages .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #FF5C00;
  background: #FFF2EB;
}

.pages .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #FF5C00;
  background: #FFF2EB;
}

.el-pagination.is-background .btn-next:hover,
.el-pagination.is-background .btn-prev:hover {
  color: #FF5C00;
  background: #FFF2EB;
}

.el-pagination .btn-prev .el-icon {
  text-align: center;
}

.sort_icon {
  margin-bottom: 2px;
}

.reverse {
  transform: rotate(180deg);
}
.xhs-table-wrap{
  // margin-top: 20px;
}
.kol_table, .xhs-table-wrap, .ks-table-wrap {
  background: #fff;
  padding: 10px;
  padding-top: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 6px;


  .belong-tags {
    display: flex;

    i {
      margin: 5px 0;
      padding: 2px 4px;
      height: 20px;
      line-height: 20px;
      background: #fff2eb;
      color: #ff5c00;
      border-radius: 2px;
      text-align: center;

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
}

.kol_table .el-table__header-wrapper,
.xhs-table-wrap .el-table__header-wrapper,
.ks-table-wrap .el-table__header-wrapper
 {
  overflow-x: auto;
}

.double {
  width: 100%;
  background: #fafafa;
  padding: 10px;
}

.double .el-checkbox__label {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #999999;
}

.double .checkbox_group_btn {
  width: 100%;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #38a1ff;
  cursor: pointer;
}

.el-table__fixed,
.el-table__fixed-right {
  box-shadow: 0 0 10px rgb(0 0 0 / 4%);
}

.table_header_title {
  text-align: center;
}

.el-table__header-wrapper {
  overflow-x: auto;
}

.el-table__header-wrapper.active {
  position: fixed;
  top: 0;
  z-index: 13;
  width: 92%;
}

.el-table th.el-table__cell {
  background-color: #fff !important;
}

.page {
  .el-table__fixed-body-wrapper {
    // top: 76px !important;
  }
}
//   .el-table__body-wrapper.active {
//   margin-top: 59px;
// }




.header_fixed_left {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  background: #fff;
  position: fixed;
  top: 0;
  height: 60px;
  width: 371px;
  display: flex;
  z-index: 20;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 10px;
}

.header_fixed_right {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  background: #fff;
  position: fixed;
  top: 0;
  height: 60px;
  width: 340px;
  display: flex;
  z-index: 20;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 66px;
  padding-right: 31px;
}

.search_out .about_search {
  display: flex;
  margin-top: 20px;

}

.search_out .about_search .about_detail {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #999999;
  /* line-height: 38px; */
  cursor: pointer;
}

.search_out .about_search .about_detail+.about_detail {
  margin-left: 50px;
}

.search_out .about_search .about_detail.active {
  color: #FF6F28;
}

.history {
  padding: 10px 0;
}

.history .history_head {
  display: flex;
  justify-content: space-between;
}

/* .history .history_head:hover {
    background-color: #FAFAFA;
  } */

.history .history_head div {
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
  padding: 0 25px;
}

.history .history_head div.btn {
  color: #999;
  cursor: pointer;
}
.history .history_list {
  max-height: 300px;
  overflow-y: auto;
}
.history .history_note {
  padding: 0 25px;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #666666;
  line-height: 40px;
  min-height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.history .history_note:hover {
  background-color: #fff5ef;
  cursor: pointer;
  color: #FF6F28;
  box-shadow: 0 2px 8px rgba(255, 111, 40, 0.15);
}

.el-popover {
  padding: 0;
}

.helper_enter {
  position: absolute;
  top: 0px;
  // right: 36px;
  display: flex;
  align-items: center;
  cursor: pointer;
  right: 28px;
}

.helper_enter img {
  width: 41px;
  height: 48px;
  margin-right: -44px;
  position: relative;
  z-index: 50;
}

.helper_enter .enter_text {
  text-align: center;
  width: 130px;
  height: 36px;
  background: #FFF2EB;
  border-radius: 18px;
  line-height: 38px;
  font-size: 13px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: 500;
  color: #FF5C00;
  box-sizing: border-box;
  padding-left: 34px;
  margin-top: 16px;
}
.helper_enter .enter_text span{
  color:#4E5969;
  font-size: 14px;
}

.stongTilte {
  font-weight: 700;
  color: #333;
  margin: 10px 0;
}

.el-cascader-node.is-active,
.el-cascader-node.in-active-path {
  color: #FF5C00 !important;
}

.el-checkbox__inner:hover {
  border-color: #FF5C00 !important;
}
// .empty-table .vxe-table--main-wrapper .vxe-table--body-wrapper.body--wrapper{
//     display: none !important;
//   }


.tabs-wrap{
  width: 100%;
  position: relative;
  .right-btns-wrap{
    position: absolute;
    right: 20px;
    top: 15px;
  }
}
</style>